/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein and carbs are 4 kcal/g; fat is 9 kcal/g.`)
};

const es_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La proteína y los carbohidratos son 4 kcal/g; la grasa es 9 kcal/g.`)
};

const de_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein und Kohlenhydrate liefern 4 kcal/g, Fett 9 kcal/g.`)
};

const nl_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiwit en koolhydraten zijn 4 kcal/g; vet is 9 kcal/g.`)
};

const fr_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protéines et glucides sont à 4 kcal/g ; les lipides à 9 kcal/g.`)
};

const it_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteine e carboidrati sono 4 kcal/g; i grassi sono 9 kcal/g.`)
};

const pt_br2_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proteína e carboidratos têm 4 kcal/g; gordura tem 9 kcal/g.`)
};

const pt_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A proteína e os hidratos têm 4 kcal/g; a gordura tem 9 kcal/g.`)
};

const ja_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タンパク質と炭水化物は4kcal/g、脂質は9kcal/gです。`)
};

const zh_macro_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`蛋白质和碳水每克 4 千卡；脂肪每克 9 千卡。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const macro_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.macro_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("macro_ex3", locale)
	if (locale === "en") return en_macro_ex3(inputs)
	if (locale === "es") return es_macro_ex3(inputs)
	if (locale === "de") return de_macro_ex3(inputs)
	if (locale === "nl") return nl_macro_ex3(inputs)
	if (locale === "fr") return fr_macro_ex3(inputs)
	if (locale === "it") return it_macro_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_macro_ex3(inputs)
	if (locale === "pt") return pt_macro_ex3(inputs)
	if (locale === "ja") return ja_macro_ex3(inputs)
	return zh_macro_ex3(inputs)
};